module.exports = {"id":"236513","name":"Lindsay Rose","rating":"71","photo":"./data/images/photos/0/236513.png","club":{"name":"FC Lorient","logo":"./data/images/clubs/FCLorient.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LindsayRose0.json
// module id = 2512
// module chunks = 0